import { useCallback } from "react";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { IconButton, useTheme } from "@mui/material";
import firePostMessage from "../../utils/firePostMessage";

function BackButton() {
  const theme = useTheme();

  const handleGoBack = useCallback(() => {
    firePostMessage({ type: "close_game", id: null });
  }, []);

  return (
    <IconButton
      onClick={handleGoBack}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: 0,
      }}
    >
      <ArrowBackIosIcon
        sx={{
          color: "#FFFFFF",
          fontSize: theme.typography.pxToRem(20),
        }}
      />
    </IconButton>
  );
}

export default BackButton;
